import React, { useEffect } from 'react';
import { renderFilter } from '../../Shared/TextHelpers';
import { ListGroupItem } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import Split from '../../Shared/Split';
import { actions } from '../../../context';

const arePracticesEqual = (newPracticeList, oldPracticeList) => {

    if(oldPracticeList.length !== newPracticeList.length) return false;

    const practiceEqualityCheck = (oldPractice) => {
        const comparePractices = (newPractice) => {
            return newPractice.id === oldPractice.id
        };
        return newPracticeList.some(comparePractices);
    };

    const comparedPractices = !!oldPracticeList.length && oldPracticeList.every(practiceEqualityCheck);

    const isSamePracticeList = !!newPracticeList.length && comparedPractices;

    return isSamePracticeList;
};

const PracticesList = () => {
    const dispatch = useDispatch();
    
    // array of practice objects
    const practiceList = useSelector((state) => state.practiceWorkflow.practiceList, arePracticesEqual);
    
    // string - set by the workflow SearchInput text field
    const filter = useSelector((state) => state.practiceWorkflow.practiceFilter);

    useEffect(() => {
        dispatch(actions.practiceWorkflow.getPractices(filter))
    }, [filter, dispatch]);

    const isPaginatedList = practiceList?.length === 10;
    const isPracticeListEmpty = practiceList?.length === 0;

    const goToWorkflowNextStep = () =>
        dispatch(
            actions.practiceWorkflow.setWorkflowStatus({
                loading: false,
                searchingPractices: false,
                editingPractice: true,
                editingRelations: false,
            })
        );

    const resetWorkflowFilter = () =>
        dispatch(actions.practiceWorkflow.setWorkflowFilter(''));

    const selectPractice = (practiceId) => {
        dispatch(actions.practiceWorkflow.getPractice(practiceId)).then(
            (res) => {
                resetWorkflowFilter();
                goToWorkflowNextStep();
            }
        );
    };

    return (
        <>
            {/* TODO: implement loading feedback and error messaging */}
            {practiceList.map((p) => {
                const {id, name, city='', stateProvince} = p;
                return (
                <ListGroupItem
                    action
                    className="hoverable py-3"
                    key={id}
                    onClick={() => selectPractice(id)}>
                    <Split>
                        <div>{renderFilter(name, filter)}</div>
                        <div>
                            {renderFilter(city, filter)}
                            {city && stateProvince ? `, ` : ``}
                            {renderFilter(stateProvince, filter)}
                        </div>
                    </Split>
                </ListGroupItem>
            )})}

            {isPaginatedList && (
                <ListGroupItem className="text-center op-9">
                    Search to see more practices
                </ListGroupItem>
            )}

            {isPracticeListEmpty && (
                <ListGroupItem className="text-center">
                    No results
                    {filter.length > 0 && ` match your search`}
                </ListGroupItem>
            )}
        </>
    );
};

export default PracticesList;
